import * as types from './actionTypes';

export function setMTD(val) {
  return {type: types.SET_MTD, setToVal: val};
}
